import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api, { getData } from "../services/api";

const AuthContext = createContext(null);
export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setAdmin(getData(r).admin))
      .catch(() => setAdmin(null))
      .finally(() => setLoading(false));
  }, []);
  const login = async (credentials) => {
    const data = getData(await api.post("/auth/login", credentials));
    setAdmin(data.admin);
    return data.admin;
  };
  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } finally {
      setAdmin(null);
    }
  };
  const value = useMemo(
    () => ({ admin, setAdmin, loading, login, logout }),
    [admin, loading],
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
export const useAuth = () => useContext(AuthContext);
